module.exports = __webpack_public_path__ + "static/img/bcg_anim_t.dcaffd0e.png";